export const BRAND_LOGO_URL = '/icarus_logo_600px.webp';
